import _ from "lodash";
import getSsn from "../common/Ssn";
import { getDodDate, getMonthAndYear, getDobDate } from "../common/DisplayDate";
import settings from "../../settings";
import pickDeep from "../../utils/nodeUtil";
import { getNodeValue } from "../common/Utils";

const includeSearchText = (personData, value) => {
  if (!value) return;
  personData.searchText = `${personData.searchText} ${value}`;
};

const getAddressData = (addressNode) => {
  const line1 = getNodeValue(addressNode, "line1");
  let addLine1 = line1 !== undefined ? line1
      : getNodeValue(addressNode, "fullAddress") || "";
  if (addLine1 === "") {
    const houseNumber = getNodeValue(addressNode, "houseNumber") || "";
    const streetName = getNodeValue(addressNode, "streetName") || "";
    addLine1 = `${houseNumber} ${streetName}` || "";
  }
  let addressText = getNodeValue(addressNode, "address1") || "";
  const city = getNodeValue(addressNode, "city") || "";
  if (city === "" && addressText === "") {
    return null;
  }
  const state = getNodeValue(addressNode, "state") || "";
  const zipcode = getNodeValue(addressNode, "zip") || "";

  const address = {
    address: addLine1,
    city,
    state,
    zipcode,
  };
  addressText = `${addressText}${addLine1}`;
  return { address, addressText };
};

export const getPersonRecordData = (
  node,
  props,
  isSilverSearch,
  isGoldSearch
) => {
  const personData = { searchText: "", addressPhoneData: [] };
  const { userAccount } = props;
  if (node !== undefined && node !== null) {
    const names = [];
    const internalID = _.get(node, "$.internalID");
    personData.internalID = internalID;
    const nameCollections = [];
    let name;
    let nameNodes = _.get(node, "names[0].name");
    if (nameNodes !== undefined && nameNodes.length > 1) {
      nameNodes = _.orderBy(nameNodes, (e) => e.$.internalNameID, ["asc"]);
    }
    _.forEach(nameNodes, (nameNode) => {
      const firstName = _.get(nameNode, "firstName[0]._", "");
      const middleInitial = _.get(nameNode, "middleInitial[0]._", "");
      const middleName = _.get(nameNode, "middleName[0]._", "");
      const lastName = _.get(nameNode, "lastName[0]._", "");
      const fullName = `${firstName} ${middleInitial !== "" ? middleInitial : middleName
        } ${lastName}`;
      includeSearchText(personData, fullName);
      if (nameNode.$.internalNameID !== "1") {
        names.push(fullName);
      } else {
        name = fullName;
      }
      if (nameNodes.length === 1) name = fullName;
      nameCollections.push({
        internalNameID: nameNode.$.internalNameID,
        name: fullName,
      });
    });
    if (!name || (name === "" && names.length > 0)) name = names[0];
    personData.name = name;
    personData.akas = names;
    personData.nameCollections = nameCollections;
    const ssnRecords = _.get(node, "SSNRecords[0]");
    if (ssnRecords) {
      const ssnRecord = _.get(ssnRecords, "SSNRecord[0]");
      personData.ssnState = _.get(ssnRecord, "state[0]._");
      personData.ssnYear = _.get(ssnRecord, "years[0]._");
      personData.ssnTired = getSsn(_.get(ssnRecord, "SSN[0]._"), {
        userAccount,
      });
    } else {
      let ssnInfo = _.get(node, "SSNInfos[0].SSNInfo[0]");
      if (ssnInfo === undefined) ssnInfo = _.get(node, "SSNInfo[0]");
      personData.ssnState = _.get(ssnInfo, "SSNState[0]._");
      personData.ssnYear = _.get(ssnInfo, "SSNYears[0]._");
      const ssn = _.get(ssnInfo, "SSN[0]._");
      const ssnTired = getSsn(ssn, { userAccount });
      personData.ssnTired = ssnTired;
    }
    let displaySsn = personData.ssnTired;
    let showCheckFullSsn = false;
    if (
      !(
        props.formData.internalID !== undefined &&
        internalID === props.formData.internalID
      ) &&
      displaySsn !== "" &&
      displaySsn !== "N/A" &&
      displaySsn.toLowerCase().indexOf("x") === -1
    ) {
      const tokens = displaySsn.split("-");
      displaySsn = `${tokens[0]}-${tokens[1]}-XXXX`;
      includeSearchText(personData, displaySsn);
    }
    personData.displaySsn = displaySsn;
    if (
      userAccount.btType !== "3" &&
      userAccount.mastSSNMask === settings.ssnMask.ShowAll &&
      !(
        props.formData.internalID !== undefined &&
        internalID === props.formData.internalID
      ) &&
      displaySsn !== "" &&
      displaySsn !== "N/A"
    ) {
      showCheckFullSsn = true;
    }
    personData.showCheckFullSsn = showCheckFullSsn;
    let dobNode = _.get(node, "DOBInfo[0].DOB[0]");
    if (dobNode === undefined) {
      dobNode = _.get(node, "DOB[0]");
    }
    if (dobNode === undefined) {
      dobNode = _.get(node, "DOBs[0].DOB[0]");
    }
    personData.dob = getDobDate(dobNode, props);
    let dodNode = _.get(node, "DOBInfo[0].DOD[0]");
    if (dodNode === undefined) {
      dodNode = _.get(node, "deceasedRecords[0].deceasedRecord[0].DOD[0]");
    }
    const dod = getDodDate(dodNode, { userAccount });
    personData.dod = dod;
    const ageAtDeath = _.get(node, "deceasedRecords[0].deceasedRecord[0].ageAtDeath[0]._");
    personData.ageAtDeath = ageAtDeath;
    includeSearchText(personData, dod);
    let age = _.get(node, "DOBInfo[0].age[0]._");
    if (age === undefined) {
      age = _.get(node, "DOBs[0].DOB[0].age[0]._");
    } else if (age === undefined) {
      age = _.get(node, "age[0]._");
    }
    if (dod === undefined && age === undefined)
      age = settings.appName === "lppolice" ? "" : "Unknown";
    personData.age = age;
    includeSearchText(personData, age);
    const addresses = _.get(node, "addresses[0].address");
    const addPhoneRows = [];
    let updatedAddresses = [];
    _.forEach(addresses, (address) => {
      let dateFrom;
      let dateTo;
      const firstDate = _.get(address, "firstDate");
      const lastDate = _.get(address, "lastDate");
      if (firstDate || lastDate) {
        dateFrom = firstDate && getMonthAndYear(firstDate[0]);
        let tokens = dateFrom.split("/");
        if (tokens.length > 1) {
          address.dateFromRaw = `${tokens[1]}${tokens[0]}`;
        }
        dateTo = lastDate && getMonthAndYear(lastDate[0]);
        tokens = dateTo.split("/");
        if (tokens.length > 1) {
          address.dateToRaw = `${tokens[1]}${tokens[0]}`;
        }
      } else {
        dateFrom = getNodeValue(address, "dateFrom");
        dateTo = getNodeValue(address, "dateTo");
      }
      if (dateFrom && dateFrom !== "") {
        const tokens = dateFrom.split("/");
        if (tokens.length > 1) {
          address.dateFromRaw = `${tokens[1] &&
            tokens[1].trim()}${tokens[0].trim()}`;
        }
      }
      if (dateTo && dateTo !== "") {
        const tokens = dateTo.split("/");
        if (dateTo.length > 1) {
          address.dateToRaw = `${tokens[1] &&
            tokens[1].trim()}${tokens[0].trim()}`;
        }
      }
      updatedAddresses.push(address);
    });
    updatedAddresses = _.orderBy(
      updatedAddresses,
      ["dateToRaw", "dateFromRaw"],
      ["desc", "desc"]
    );

    const ssnRisks = [];
    const ssnNodes = _.get(node, "SSNInfos[0].SSNInfo");
    if (ssnNodes) {
      _.forEach(ssnNodes, (ssnNode) => {
        const ssnRisk = _.get(ssnNode, "SSNRisk[0]._");
        if (ssnRisk && ssnRisk !== "") {
          const ssnRiskText = `${_.get(ssnNode, "SSN[0]._", "")} - ${ssnRisk}`;
          includeSearchText(personData, ssnRiskText);
          ssnRisks.push(ssnRiskText);
        }
      });
    }
    const silverPhones = [];
    if (isSilverSearch || isGoldSearch) {
      const phoneNodes = _.get(node, "phones[0].phone");
      if (phoneNodes && phoneNodes.length > 0) {
        _.forEach(phoneNodes, (phoneNode) => {
          const score = parseInt(_.get(phoneNode, "score[0]._", "0"), 10);
          let phone = getNodeValue(phoneNode, "phoneNumber");
          if (phone === undefined || phone === "") {
            phone = getNodeValue(phoneNode, "_");
          }
          if (phone && silverPhones.indexOf(phone) === -1) {
            includeSearchText(personData, phone);
            silverPhones.push({ score, phone });
          }
        });
      }
    }
    personData.ssnRisks = ssnRisks;
    _.forEach(updatedAddresses, (address, addIndex) => {
      let phones = [];
      if (!(isSilverSearch || isGoldSearch)) {
        let phoneNodes = [];
        pickDeep(address, "phone", phoneNodes);
        if (phoneNodes !== undefined) {
          phoneNodes = _.flatten(phoneNodes);
          _.forEach(phoneNodes, (phoneInfo) => {
            const score = parseInt(_.get(phoneInfo, "score[0]._", "0"), 10);
            let phone = _.get(phoneInfo, "phoneNumber[0]._");
            if (phone === undefined || phone === "") {
              phone = _.get(phoneInfo, "_");
            }
            if (phones.indexOf(phone) === -1 && phone !== undefined) {
              includeSearchText(personData, phone);
              phones.push({ score, phone });
            }
          });
        }
      } else if (addIndex === 0) {
        phones = silverPhones;
      }

      const recType = _.get(address, "recordType[0]._");
      const firstDate = _.get(address, "firstDate");
      const lastDate = _.get(address, "lastDate");
      const dateFrom =
        getNodeValue(address, "dateFrom") ||
        (firstDate && getMonthAndYear(firstDate[0])) ||
        "";
      const dateTo =
        getNodeValue(address, "dateTo") ||
        (lastDate && getMonthAndYear(lastDate[0])) ||
        "";
      const dateRange = `${dateFrom}-${dateTo}`;
      includeSearchText(personData, dateRange);
      const addressData = getAddressData(
        address
      );
      if (addressData !== null) {
        includeSearchText(personData, addressData.addressText);
        addPhoneRows.push({ recType, dateRange, addressData, phones });
      }
    });
    personData.addressPhoneData.push(addPhoneRows);
  }
  return personData;
};

export default getPersonRecordData;



// WEBPACK FOOTER //
// ./src/components/searchresults/PersonRecordData.js